import { Dictionary } from '@feedyou/schema'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { Comment, CommentId } from '../../features/serverComments'

export type CommentsState = {
  showResolved: boolean
  isCommentSubmitting: boolean
  editedCommentId: CommentId | null
  commentDrafts: Dictionary<CommentId, Comment>
  pendingEdits: Dictionary<CommentId, { text: string }>
}

export const initialState: CommentsState = {
  showResolved: false,
  editedCommentId: null,
  commentDrafts: {},
  pendingEdits: {},
  isCommentSubmitting: false
}

export const commentsState = createSlice({
  name: 'comments',
  initialState,
  reducers: {
    showResolved: state => {
      state.showResolved = true
    },
    hideResolved: state => {
      state.showResolved = false
    },
    setCommentSubmitting: (state, action: PayloadAction<boolean>) => {
      state.isCommentSubmitting = action.payload
    },
    setEditedCommentId: (state, action: PayloadAction<CommentId | null>) => {
      state.editedCommentId = action.payload
    },

    addCommentDraft: (state, action: PayloadAction<Comment>) => {
      const comment = action.payload
      state.commentDrafts[comment.id] = comment
    },
    deleteCommentDraft: (state, action: PayloadAction<CommentId>) => {
      delete state.commentDrafts[action.payload]
    },

    modifyPendingEdit: (state, action: PayloadAction<{ id: CommentId; text: string }>) => {
      const { id, text } = action.payload
      state.pendingEdits[id] = { text }
    },
    removePendingEdit: (state, action: PayloadAction<CommentId>) => {
      const id = action.payload
      delete state.pendingEdits[id]
    }
  }
})

export const actions = commentsState.actions
export const reducer = commentsState.reducer
